module.exports = __webpack_public_path__ + "static/media/chevron-left.8bc4f190.svg";